export default __webpack_public_path__ + "static/media/7.12.df3b72f3.jpg";